  /* eslint-disable */
import React, {useState, useRef, useEffect} from 'react'
const Icon = styled.img``;
import Svg from "_assets/svg";
import Search from 'components/SearchV2';
import _ from 'lodash';

// library
import styled from 'styled-components';

// style
import './DropdownV3.scss'

function DropdownV3(props) {
  const {
    isListSearch, 
    setSelectedSearch, 
    isSelected, 
    placeholder, 
    className, 
    anySelected, 
    useSearch, 
    typeAction, 
    countAction,
    buttonData,
  } = props;
  // console.log('className', className)
  const [isShowListSearch, setShowListSearch] = useState(false)
  const [isDisableButton, setDisableButton] = useState(false)
  const [isLoopingList, setLoopingList] = useState({})
  const [isDataDropdown, setDataDropdown] = useState([])
  const [isSearch, setSearch] = useState('');
  const [timer, setTimer] = useState(null)
  const container = useRef();

  useEffect(()=>{
    setLoopingList(isSelected)
  },[isSelected,anySelected, isDataDropdown, buttonData])
  
  useEffect(()=>{
    setDataDropdown(isListSearch)
  }, [isListSearch])

  function chooseSearchType(item){
    setLoopingList(item)
    setSelectedSearch(item)
    setShowListSearch(false)
  }

  function handleClickSearch(){
    setShowListSearch(!isShowListSearch)
  }

  function handleSearch(e) {
    let key = e
    delayedQuery(key);
  }
  
  const delayedQuery = async (q) => {
    setSearch(q);
  
    clearTimeout(timer)
    
    const newTimer = setTimeout(async() => {

      if(q){
        // search manual not by get api
        const dataSearch = [];
        const upper = q.toUpperCase();
        for (let i = 0; i < isDataDropdown.length; i++) {
          if (isDataDropdown[i].name.toUpperCase().indexOf(upper) > -1) {
            dataSearch.push(isDataDropdown[i]);
          }
        }
        if (dataSearch.length > 0) {
          setDataDropdown(dataSearch);
        } else {
          setDataDropdown([]);
        }
      }else{
        setDataDropdown(isListSearch);
      }
    }, 500)
  
    setTimer(newTimer)
  }

  useEffect(() => {
    function handleClickOutside(event) {
        if (container.current && !container.current.contains(event.target)) {
          setShowListSearch(false);
        }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [container])

  const dataVisitWeb = [];
  const dataPhoneNumber = [];
  const dataPromoCode = [];
  const dataMarketing = [];
  if(buttonData && typeAction){
    buttonData.forEach((item) => {
      if(item.buttonType === 'CTA'){
        item.buttons.forEach((result) => {
          if(result.typeCTA.value === "visit_web"){
            dataVisitWeb.push(result);
          }
          if(result.typeCTA.value === "call_phone_number"){
            dataPhoneNumber.push(result);
          }
          if(result.typeCTA.value === "copy_promo_code"){
            dataPromoCode.push(result);
          }
        })
      }
  
      if(item.buttonType === 'QUICK_REPLY'){
      
        item.buttons.forEach((result) => {
          if(result.typeCTA.value === "marketing_disapproval"){
            dataMarketing.push(result);
          }
        })
      }
      
    })
  }

  return (
    <div className={`${className} dropdown_v3`} ref={container}>
      <div onClick={handleClickSearch} className='selected form-control'>
        <span className={`cl-neutral500 fsize-14 fweight-400 mb-0 capitalize`}>{isLoopingList?.name ? _.startCase(isLoopingList?.name) : placeholder}</span>
        <Icon src={Svg.chevron_right.default} className={`ms-2 ${isShowListSearch ? 'rotate_180' : 'rotate_0'}`}/>
      </div>
      {isShowListSearch &&
      <div className='dropdown p-0'>
        <div className='list_search'>
          {useSearch && 
            <Search 
              onChange={handleSearch} 
              value={isSearch} 
              placeholder="Search ..." 
              className="mb-1 px-2 w-100"
              minWidth="100%"
              color="#7A869A"
              noIcon
            />
          }
          {isDataDropdown.map((item, idx) =>{
            console.log('values', item, isSelected, isLoopingList)
            return <span className={`
            ${item.disable ? 'event_disable' : ''} 

            ${item.value === 'visit_web' && dataVisitWeb.length === 2 ? 'event_disable' : ''} 
            ${item.value === 'call_phone_number' && dataPhoneNumber.length === 1 ? 'event_disable' : ''} 
            ${item.value === 'copy_promo_code' && dataPromoCode.length === 1 ? 'event_disable' : ''} 
            ${item.value === 'marketing_disapproval' && dataMarketing.length === 1 ? 'event_disable' : ''} 
            cl-neutral500 fsize-14 fweight-400 mb-0 px-3`} onClick={()=>chooseSearchType(item)} key={idx}>
              {item.name}
            </span>
          })}
          {isDataDropdown.length === 0 && <span className='fweight-400 fsize-14 cl-neutral100'>No Result</span>}
        </div>
      </div>
      }
    </div>
  )
}

export default DropdownV3